import { Component, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import templateContent from "./main-nav.html";

import allContentListView from "../../views/allContentList/allContentListView";
import contentPackListView from "../../views/content-packs/contentPackListView";
import customersView from "../../views/customers/customersView";
import customTagsView from "../../views/custom-tags/customTagsView";
import dashboardView from "../../views/dashboard/dashboardView";
import devToolsView from "../../views/devTools/devToolsView";
import imagesBulkUploadView from "../../views/imagesBulkUpload/imagesBulkUploadView";
import loginView from "../../views/login/loginView";
import passwordRecoveryView from "../../views/passwordRecovery/passwordRecoveryView";
import userListView from "../../views/users/userListView";
import volumeCollectionView from "../../views/volumeCollection/volumeCollectionView";
import textsBulkInsertView from "../../views/textsBulkInsert/textsBulkInsertView";

class MainNavComponent extends Component {
	constructor () {
		super("mainNavComponent");
		this.addTemplate("", templateContent);
	}
	
	beforeLoad () {
		Shark.set({
			__navAllContentListCSSClass: ["allContentListView"].includes(Shark.activePage.id) ? "active " : "nd ",
			__navContentPackCSSClass: ["contentPackDetailView", "contentPackListView"].includes(Shark.activePage.id) ? "active " : "nd ",
			__navImagesBulkUploadCSSClass: ["imagesBulkUploadView"].includes(Shark.activePage.id) ? "active " : "nd ",
			__navTextsBulkUploadCSSClass: ["textsBulkInsertView"].includes(Shark.activePage.id) ? "active " : "nd ",
			__navCustomersCSSClass: ["customersView"].includes(Shark.activePage.id) ? "active " : "nd ",
			__navCustomTagsViewCSSClass: ["customTagsView"].includes(Shark.activePage.id) ? "active " : "nd ",
			__navDashboardCSSClass: ["dashboardView"].includes(Shark.activePage.id) ? "active " : "nd ",
			__navUserCSSClass: ["userListView"].includes(Shark.activePage.id) ? "active " : "nd ",
			__showMenu: !["loginView", "passwordRecoveryView", "passwordResetView", "registerView"].includes(Shark.activePage.id),
		});
	}
	
	goBackToLoginViewBtn_clickHandler (event) {
		this.openPage(event, loginView, {urlSearchParams: null});
	}

	navBackBtn_clickHandler () {
		history.back();
	}

	navAllContentListViewBtn_clickHandler (event) {
		this.openPage(event, allContentListView);
	}

	navContentPackViewBtn_clickHandler (event) {
		this.openPage(event, contentPackListView);
	}
	
	navCustomersViewBtn_clickHandler (event) {
		this.openPage(event, customersView);
	}

	navCustomTagsViewBtn_clickHandler (event) {
		this.openPage(event, customTagsView);
	}

	navDashboardViewBtn_clickHandler (event) {
		this.openPage(event, dashboardView);
	}

	navDevToolsViewBtn_clickHandler (event) {
		this.openPage(event, devToolsView);
	}

	navImagesBulkUploadViewBtn_clickHandler (event) {
		this.openPage(event, imagesBulkUploadView);
	}

	navLogOutBtn_clickHandler (event) {
		NousCore.api.abandonSession()
		.then(() => {
			localStorage.removeItem("preserveLogin");
			this.openPage(event, loginView);
		});
	}

	navPasswordRecoveryViewBtn_clickHandler (event) {
		this.openPage(event, passwordRecoveryView, {urlSearchParams: null});
	}
	
	navTextsBulkUploadViewBtn_clickHandler (event) {
		this.openPage(event, textsBulkInsertView);
	}

	navUserListViewBtn_clickHandler (event) {
		this.openPage(event, userListView, {urlSearchParams: null});
	}
	
	navVolumeCollectionListViewBtn_clickHandler (event) {
		this.openPage(event, volumeCollectionView, {urlSearchParams: null});
	}

	openPage (event, page) {
		event.preventDefault();
		event.stopPropagation();

		const { currContent } = Shark.get();

		if (currContent && (!currContent.isDirty() || confirm(`Ci sono delle modifiche non salvate, se prosegui andranno perdute.\n\nVuoi davvero proseguire?`))) {
			currContent.restore();
		}

		Shark.openPage(page, {urlSearchParams: null});
	}
}

const mainNavComponent = new MainNavComponent();

Shark.registerComponent(mainNavComponent);

export default mainNavComponent;
